import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  Chart,
  CategoryScale,
  DoughnutController,
  ArcElement,
  PointElement,
  LinearScale,
  Legend,
} from 'chart.js';

import { colors } from './defaults';

export default function DonutChart({
  className,
  color,
  backColor,
  labels,
  values,
  cutout,
  aspectRatio,
  hideLegend,
}) {
  const chartRef = useRef(false);
  const options = {
    plugins: {
      legend: {
        display: !hideLegend,
      },
    },
    cutout: cutout || '90%',
    aspectRatio: aspectRatio || 2,
  };

  const labelsColors = [];
  const labelsBackgroundColors = [];

  color.forEach((colorString) => {
    labelsColors.push(colors[colorString]);
  });

  backColor.forEach((colorString) => {
    labelsBackgroundColors.push(colors[colorString]);
  });

  const data = {
    labels,
    datasets: [
      {
        data: values,
        borderWidth: [0, 0],
        backgroundColor: labelsColors,
        hoverBackgroundColor: labelsBackgroundColors,
      },
    ],
  };
  useEffect(() => {
    Chart.register(
      DoughnutController,
      CategoryScale,
      ArcElement,
      PointElement,
      LinearScale,
      Legend
    );
    Chart.defaults.font.family =
      'Poppins, system-ui, -apple-system, Roboto, Arial, system-ui, -apple-system, sans-serif';
    Chart.defaults.plugins.tooltip.padding = 10;
    Chart.defaults.plugins.tooltip.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    Chart.defaults.scale.ticks.color = 'rgba(0, 0, 0, 0.4)';

    const chart = new Chart(chartRef.current, {
      type: 'doughnut',
      options,
      data,
    });
    return () => chart.destroy();
  }, [options, data]);
  return <canvas className={className} ref={chartRef} />;
}

DonutChart.defaultProps = {
  className: '',
  color: ['primary', 'indigo'],
  backColor: ['gray', 'gray'],
  cutout: '90%',
  aspectRatio: 2,
  hideLegend: false,
  labels: [],
  values: [],
};

DonutChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.number),
  aspectRatio: PropTypes.number,
  color: PropTypes.arrayOf(PropTypes.string),
  backColor: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  cutout: PropTypes.string,
  hideLegend: PropTypes.bool,
};
